import { Badge, Col, Container, Row } from 'react-bootstrap';

// images
import aws from "assets/images/brands/AWS.png";
const Client = () => {
    return (
      <section className="py-5 mb-lg-6 position-relative" data-aos="fade-up">
        <Container>
          <Row>
            <Col className="text-center">
              <Badge pill bg="" className="badge-soft-info px-2 py-1">
                Platforms
              </Badge>
              <h1 className="display-5 fw-medium">We are powered by</h1>
              <p className="text-muted mx-auto">
                Powered by industry-leading companies, ensures reliability,
                efficiency, and cutting-edge solutions tailored to your needs.
              </p>
            </Col>
          </Row>
          
            <div
              className="offset-1"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight:"10%",
                marginTop:"2%"
              }}
            >
              <img src={aws} alt="google" height="60" />
          </div>
        </Container>
      </section>
    );
};

export default Client;
